import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { Home as HomeIcon, RestaurantMenu as RestaurantMenuIcon } from "@mui/icons-material";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DashboardIcon from "@mui/icons-material/Dashboard";

// All possible menu items
const allMenuItems = [
  { text: "Subscription", icon: <HomeIcon />, route: "/mainladdingpage", vertical: "SUBSCRIPTION" },
  { text: "Food & Beverages", icon: <DashboardIcon />, route: "/foodladingpage", vertical: "FOOD_AND_BEVERAGES" },
  { text: "Catering & Services", icon: <RestaurantMenuIcon />, route: "/cateringlading", vertical: "CATERINGS_SERVICES" },
  { text: "Logistics & Supply", icon: <LocalShippingIcon />, route: "/logisticsladingpage", vertical: "LOGISTICS_SUPPLY" },
  { text: "Fresh & Grocery", icon: <ShoppingBasketIcon />, route: "/groceryladingpage", vertical: "FRESH_GROCERIES" },
];

const Mainsidebar = () => {
  const [open, setOpen] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isNarrowerWidthScreen = useMediaQuery("(max-width:1350px)");

  // Media queries
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isBelow1315 = useMediaQuery("(max-width:1315px)");
  const isBetween1315And1399 = useMediaQuery("(min-width:1315px) and (max-width:1399px)");
  const isAbove1400 = useMediaQuery("(min-width:1450px)");

  // const drawerVariant = isBelow1300 ? "persistent" : "permanent";

  let drawerWidth = 189; // default

  if (isBelow1315) {
    drawerWidth = 176;
  } else if (isBetween1315And1399) {
    drawerWidth = 190;
  } else if (isAbove1400) {
    drawerWidth = 208;
  }


  const getIconSize = () => (isMobile ? "small" : "medium");
  const getTextSize = () => (isMobile ? "11px" : isTablet ? "12px" : "13px");

  // Set initial open state
  useEffect(() => {
    if (isMobile) setOpen(false);
    else setOpen(true);
  }, [isMobile]);

  // Filter menu based on businessVerticals from localStorage (login response)
  // Filter menu based on businessVerticals, but always include "Subscription"
  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginResponse"));
    const businessVerticals = loginData?.businessVerticals || [];

    const filteredMenu = allMenuItems.filter(
      (item) =>
        item.text === "Subscription" || businessVerticals.includes(item.vertical)
    );

    setMenuItems(filteredMenu);
  }, []);


  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: isMobile ? 60 : 88,
          left: isMobile ? 10 : 70,
          zIndex: 1500,
        }}
      >
        <IconButton onClick={() => setOpen(!open)} sx={{ color: "#b15cd6" }}>
          <MenuIcon fontSize={isMobile ? "medium" : "large"} />
        </IconButton>
      </Box>

      <Drawer
        anchor="left"
        variant={isMobile ? "temporary" : "persistent"}
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            marginTop: isMobile ? "89px" : "80px",
            height: isMobile ? "calc(100vh - 60px)" : "calc(100vh - 80px)",
            width: drawerWidth,
            backgroundColor: "#fff",
            border: "3px solid white",
          },
        }}
        ModalProps={{ keepMounted: true }}
      >
        <Box sx={{ width: "100%", height: "100%", overflowY: "auto", marginTop: isMobile ? "10px" : "47px" }}>
          <List>
            {menuItems.length === 0 ? (
              <Box sx={{ color: "gray", padding: "1rem", textAlign: "center", fontSize: getTextSize() }}>
                No menu items found
              </Box>
            ) : (
              menuItems.map((item, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton
                    sx={{
                      background: location.pathname === item.route ? "#A055B0" : "#B276C3",
                      borderRadius: "20px",
                      marginBottom: "10px",
                      color: "#fff",
                      "&:hover": { background: "#A055B0" },
                      padding: "10px 16px",
                    }}
                    onClick={() => {
                      navigate(item.route);
                      if (isMobile) setOpen(false);
                    }}
                  >
                    <ListItemIcon sx={{ color: "#fff", minWidth: "27px" }}>
                      {React.cloneElement(item.icon, { fontSize: getIconSize() })}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      primaryTypographyProps={{
                        style: { fontSize: getTextSize(), fontWeight: "bold" },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Mainsidebar;
